import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Input } from "../ui/input";
import {
  getCustomerandVendorPaymentList,
  getAccounChargesList,
  GetAddressBookAccountVendorDetails,
  GetAccountAdressbookModuleList,
  GetAccountAdressbookBasisList,
} from "@/redux/Common/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateAddressBookAccount,
  getAddressByID,
  GetAddressBookAccountByID,
  DeleteAccountChargeById
} from "@/redux/Address/actions";
import { de } from "date-fns/locale";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";
import { showToast } from "@/redux/Toast/actions";
import { callLoader } from "@/redux/Loader/actions";
import SectionHeader from "./SectionHeader";

const AddressBookAccount = ({
  bookingData,
  onToggle,
  expandedSections,
  standardTermsList,
  activeTab
}) => {
  const inputClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all";
  const selectClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all appearance-none cursor-pointer";
  const dispatch = useDispatch();
        const { isAnimate } = useSelector((state) => state.toast);

  const [basisList, setBasisList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [descriptionData, setDescriptionData] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [activeRow, setActiveRow] = useState(null);
 const [isAccountingLoaded, setIsAccountingLoaded] = useState(false);



 

  
  // Track active field
  const [activeField, setActiveField] = useState(null);
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  const [charges, setCharges] = useState([]);

  // Autocomplete for Description & Vendor
  const handleAutocompleteChange = async (index, field, value) => {
    const updated = [...charges];
    updated[index][field] = value;
    setCharges(updated);

    setActiveRow(index);
    setActiveField(field);

    if (!value || value.trim().length < 2) {
      setSuggestions([]);
      setVendorSuggestions([]);
      return;
    }

    if (field === "description") {
      try {
        const res = await dispatch(getAccounChargesList(value.trim()));
        setSuggestions(res || []);
      } catch (err) {
        console.error("Charge search failed", err);
        setSuggestions([]);
      }
    } else if (field === "vendor") {
      try {
        const res = await dispatch(
          GetAddressBookAccountVendorDetails(value.trim()),
        );
        setVendorSuggestions(res || []);
      } catch (err) {
        console.error("Vendor search failed", err);
        setVendorSuggestions([]);
      }
    }
  };

  // Handle selecting an item
  const handleSelect = (index, field, item) => {
    const updated = [...charges];

    if (field === "description") {
      updated[index].description = item.chargesdescription;
      updated[index].descriptionId = item.descriptionId;
      updated[index].descriptioncode = item.descriptioncode;
    } else {
      updated[index].vendor = item.vendorName;
      updated[index].vendorId = item.vendorId;
    }

    setCharges(updated);
    setSuggestions([]);
    setVendorSuggestions([]);
    setActiveRow(null);
    setActiveField(null);
  };

  // Initial 5 rows

  const [AccountformData, setAccountFormData] = useState({
    ddlvendpayTerms: "",
    ddlcustpayTerms: "",
    customerCreditLimit: "",
    vendorCreditAmount: "",
    activeRates: false,
    customerOnHold: false,
  });

  useEffect(() => {
    // Fetch payment terms when component mounts
    const fetchPaymentTerms = async () => {
      try {
        const terms = await dispatch(getCustomerandVendorPaymentList());
        // const charges = await dispatch(getAccounChargesList(""));
        // setDescriptionData(charges);
        setAccountFormData(terms);
      } catch (error) {
        console.error("Error fetching payment terms:", error);
      }
    };

    fetchPaymentTerms();
  }, [bookingData]);

useEffect(() => {
  if (isAccountingLoaded) return; // 🔒 HARD STOP
  if (!moduleList.length || !basisList.length) return;

  setCharges(
    Array.from({ length: 5 }, () => ({
      description: "",
      basis: basisList[0]?.value || "",
      vendor: "",
      sell: "0.00",
      buy: "0.00",
      module: moduleList[0]?.value || "",
    }))
  );
}, [moduleList, basisList, isAccountingLoaded]);



  useEffect(() => {
    if (activeRow !== null && activeField === "description") {
      setSuggestions(descriptionData || []);
    }
  }, [descriptionData]);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const res = await dispatch(GetAccountAdressbookModuleList()); // your API action
        setModuleList(res || []);
      } catch (err) {
        console.error("Module fetch failed", err);
        setModuleList([]);
      }
    };
    fetchModules();
  }, []);

  useEffect(() => {
    const fetchBasisList = async () => {
      try {
        const res = await dispatch(GetAccountAdressbookBasisList()); // API call
        if (res && Array.isArray(res)) {
          setBasisList(res); // should be array of { value, label }
        }
      } catch (err) {
        console.error("Failed to fetch basis list:", err);
      }
    };

    fetchBasisList();
  }, [dispatch]);

  const AccounthandleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAccountFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle input changes
  const tablehandleChange = (index, field, value) => {
    const updated = [...charges];
    updated[index][field] = value;
    setCharges(updated);
  };

  // Add new blank row
  const handleAddRow = () => {
    setCharges([
      ...charges,
      {
        description: "",
        basis: basisList[0]?.value || "", // first basis from API or empty
        vendor: "",
        sell: "0.00",
        buy: "0.00",
        module: moduleList[0]?.value || "", // first module from API or empty
      },
    ]);
  };

  // Delete row
  // const handleDeleteRow = (index) => {
  //   const updated = charges.filter((_, i) => i !== index);
  //   setCharges(updated);
  // };

const handleDeleteRow = async (index) => {
  const row = charges[index];

  if (!window.confirm("Are you sure you want to delete this charge?")) return;

  if (row?.id) {
    await (DeleteAccountChargeById(row.id));
  }

  setCharges(prev => prev.filter(item => item !== row));
};





  
// Save handler
const handleSave = async () => {

  // Filter and prepare charges
  const filledCharges = charges
    .filter(row => row.description && row.description.trim() !== "")
    .map((row, index) => ({
      id: row.id || index + 1, // If no ID, generate sequential
      descriptionId: Number(row.descriptionId) || 0,
      description: row.description,
      descriptioncode: row.descriptioncode,
      basis: row.basis,
      sell: Number(row.sell) || 0,
      buy: Number(row.buy) || 0,
      vendor: row.vendor,
      vendorId: row.vendorId ? Number(row.vendorId) : 0,
      division: row.module 
    }));

  if (filledCharges.length === 0) {
    dispatch(showToast("Please enter at least one charge description to save.", "error"));

    return;
  }
   
  const resultData = await dispatch(getAddressByID(bookingData));
  // Prepare payload in correct JSON format
  const payload = {
    accountData: {
      companyID: resultData?._Company?.id || 0,
      customerCreditLimit: AccountformData.customerCreditLimit || "0",
      vendorCreditAmount: AccountformData.vendorCreditAmount || "0",
      customerPaymentTerms: AccountformData.ddlcustpayTerms
        ? Number(AccountformData.ddlcustpayTerms)
        : 0,
      vendorPaymentTerms: AccountformData.ddlvendpayTerms
        ? Number(AccountformData.ddlvendpayTerms)
        : 0,
      activeRates: !!AccountformData.activeRates,
      customerOnHold: !!AccountformData.customerOnHold,
      modifiedBy: "admin", // replace with logged-in user
    },
    charges: filledCharges
  };

  try {
    const AccDetails = await CreateAddressBookAccount(payload);
    console.log("AccDetails", AccDetails);

    if (AccDetails?.statuscode === 200 || AccDetails?.statuscode === 201) {
   
       dispatch(showToast("Record saved successfully", "success",true));

      // // Reset form fields
      // setAccountFormData({
      //   ddlcustpayTerms: "",
      //   ddlvendpayTerms: "",
      //   customerCreditLimit: "",
      //   vendorCreditAmount: "",
      //   activeRates: false,
      //   customerOnHold: false,
      // });

      // setCharges(
      //   Array.from({ length: 5 }, () => ({
      //     id: 0,
      //     descriptionId: 0,
      //     description: "",
      //     descriptioncode: 0,
      //     basis: basisList[0]?.value || "",
      //     sell: 0,
      //     buy: 0,
      //     vendor: "",
      //     vendorId: 0,
      //     module: 1, // default division
      //   }))
      // );

      // setSuggestions([]);
      // setVendorSuggestions([]);
      // setActiveRow(null);
      // setActiveField(null);
    }
  } catch (err) {
    console.error(err);
    alert("Error saving data.");
     dispatch(showToast("Error saving data.", "error"));
  }
};


useEffect(() => {
  const loadAccountingData = async () => {
    if (activeTab !== "accounting") return;
    dispatch(callLoader(1));
    try {
      // ✅ WAIT for result
      const addressData = await dispatch(getAddressByID(bookingData));

      const companyId = addressData?._Company?.id;
      if (!companyId) return;

      // ✅ Now call accounting API
      const res = await dispatch(GetAddressBookAccountByID(companyId));

      const data = res;
      if (!data) return;

       // ✅ USE IT HERE 👇
      setCharges(normalizeCharges(res.charges));
      setIsAccountingLoaded(true); // 🔒 tells app DB data is loaded

      // ✅ Bind FORM data
      setAccountFormData({
        ddlcustpayTerms: data.accountData.customerPaymentTerms || "",
        ddlvendpayTerms: data.accountData.vendorPaymentTerms || "",
        customerCreditLimit: data.accountData.customerCreditLimit || "",
        vendorCreditAmount: data.accountData.vendorCreditAmount || "",
        activeRates: !!data.accountData.activeRates,
        customerOnHold: !!data.accountData.customerOnHold,
      });

      // ✅ Bind TABLE data
      setCharges(
        Array.isArray(data.charges)
          ? data.charges.map((row) => ({
              id: row.id,
              descriptionId: row.descriptionId,
              description: row.description,
              descriptioncode: row.descriptionCode,
              basis: row.basis,
              sell: row.sell,
              buy: row.buy,
              vendor: row.vendor,
              vendorId: row.vendorId,
              module: row.division,
            }))
          : []
      );
    } catch (err) {
      console.error("Accounting load failed:", err);
    }finally {
      dispatch(callLoader(0)); // ✅ STOP LOADER
    }
  };

  loadAccountingData();
}, [activeTab, bookingData, dispatch]);


const normalizeCharges = (dbCharges = []) => {
  const rows = dbCharges.map(row => ({
    id: row.id,
    descriptionId: row.descriptionId,
    description: row.description,
    descriptioncode: row.descriptionCode,
    basis: row.basis,
    sell: row.sell,
    buy: row.buy,
    vendor: row.vendor,
    vendorId: row.vendorId,
    module: row.division,
  }));

  while (rows.length < 5) {
    rows.push({
      description: "",
      basis: basisList[0]?.value || "",
      vendor: "",
      sell: "0.00",
      buy: "0.00",
      module: moduleList[0]?.value || "",
    });
  }

  return rows;
};





  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="p-6 space-y-6 pb-12"
    >
      <>
        <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
          <SectionHeader
            icon={MapPin}
            title="Accounting Details"
            color="bg-emerald-600"
            section="s3"
            expandedSections={expandedSections}
              toggleSection={onToggle}
          />

          <div className="p-4 border-t border-slate-200 dark:border-slate-800">
            <div className="grid grid-cols-4 gap-6 items-start">
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Customer Payment Terms:
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    name="ddlcustpayTerms"
                    value={AccountformData?.ddlcustpayTerms}
                    onChange={AccounthandleInputChange}
                  >
                    {standardTermsList?.map((terms, key) => (
                      <option key={key} value={terms.termsID}>
                        {terms.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Customer Credit Limit: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                 <Input
  type="text"
  className={inputClass}
  value={AccountformData.customerCreditLimit ? `$${AccountformData.customerCreditLimit}` : ""}
  onChange={(e) => {
    // Keep only numbers
    const value = e.target.value.replace(/[^0-9.]/g, "");
    setAccountFormData({
      ...AccountformData,
      customerCreditLimit: value, // store plain number
    });
  }}
/>

                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Vendor Payment Terms:
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    name="ddlvendpayTerms"
                    value={AccountformData?.ddlvendpayTerms}
                    onChange={AccounthandleInputChange}
                  >
                    {standardTermsList?.map((terms, key) => (
                      <option key={key} value={terms.termsID}>
                        {terms.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Vendor Credit Amount: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  

                    <Input
    type="text"
    className={inputClass}
    value={AccountformData.vendorCreditAmount ? `$${AccountformData.vendorCreditAmount}` : ""}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9.]/g, ""); // keep only numbers
      setAccountFormData({
        ...AccountformData,
        vendorCreditAmount: value, // store plain number
      });
    }}
  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Active Rates:
                </label>
                <div className="col-span-12">
                  <Input
                    type="checkbox"
                    className="w-5 h-5"
                    name="activeRates"
                    checked={AccountformData.activeRates || false} // bind to state
                    onChange={AccounthandleInputChange}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Customer on Hold:
                </label>
                <div className="col-span-12">
                  <Input
                    type="checkbox"
                    className="w-5 h-5"
                    name="customerOnHold"
                    checked={AccountformData.customerOnHold || false} // bind to state
                    onChange={AccounthandleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Address List  */}
        <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
          <div className="bg-slate-700 p-4">
            <h3 className="text-base font-semibold text-white flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              Additional Charges Section*
            </h3>
          </div>

          <div className="p-4 border-t border-slate-200 dark:border-slate-800">
            <div className="overflow-x-auto">
              <table className="w-full text-xs border border-slate-300">
                <thead>
                  <tr className="bg-green-700 text-white">
                    <th className="px-2 py-2 text-left font-semibold uppercase">
                      Charges Description
                    </th>
                    <th className="px-2 py-2 text-left font-semibold uppercase">
                      Basis
                    </th>
                    <th className="px-2 py-2 text-left font-semibold uppercase">
                      Vendor
                    </th>
                    <th className="px-2 py-2 text-center font-semibold uppercase">
                      Sell
                    </th>
                    <th className="px-2 py-2 text-center font-semibold uppercase">
                      Buy
                    </th>
                    <th className="px-2 py-2 text-center font-semibold uppercase">
                      Module
                    </th>
                    <th className="px-2 py-2 text-center font-semibold uppercase">
                      Del
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {charges.map((row, index) => (
                    <tr
                      key={index}
                      className="border-t border-slate-200 bg-slate-50 text-slate-900 dark:text-slate-900"
                    >
                      {/* Description */}
                      <td className="px-2 py-2 relative">
                        <input
                          type="text"
                          className="w-full border border-slate-300 rounded px-2 py-1 
             bg-yellow-50 text-xs 
             text-slate-900 dark:text-slate-900 
             caret-slate-900"
                          value={row.description}
                          onChange={(e) =>
                            handleAutocompleteChange(
                              index,
                              "description",
                              e.target.value,
                            )
                          }
                        />

                        {/* Suggestions dropdown */}
                        {activeRow === index &&
                          activeField === "description" &&
                          suggestions.length > 0 && (
                            <ul className="absolute top-full left-0 w-full bg-white border border-slate-300 max-h-40 overflow-y-auto z-10">
                              {suggestions.map((item) => (
                                <li
                                  key={item.descriptioncode}
                                  className="px-2 py-1 hover:bg-slate-100 cursor-pointer text-xs"
                                  onClick={() =>
                                    handleSelect(index, "description", item)
                                  }
                                >
                                  {item.chargesdescription}
                                </li>
                              ))}
                            </ul>
                          )}
                      </td>

                      {/* Basis */}
                      <td className="px-2 py-2">
                        <select
                          className="w-full h-8 border border-slate-400 rounded px-2 text-xs bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-green-600"
                          value={row.basis}
                          onChange={(e) =>
                            tablehandleChange(index, "basis", e.target.value)
                          }
                        >
                          {basisList.map((opt) => (
                            <option key={opt.id} value={opt.name}>
                              {opt.name}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* Vendor */}
                      <td className="px-2 py-2 relative">
                        <input
                          type="text"
                          className="w-full border border-slate-300 rounded px-2 py-1 
             bg-white text-xs 
             text-slate-900 dark:text-slate-900 
             caret-slate-900"
                          value={row.vendor}
                          onChange={(e) =>
                            handleAutocompleteChange(
                              index,
                              "vendor",
                              e.target.value,
                            )
                          }
                        />

                        {/* Suggestions */}
                        {activeRow === index &&
                          activeField === "vendor" &&
                          vendorSuggestions.length > 0 && (
                            <ul className="absolute top-full left-0 w-full bg-white border border-slate-300 max-h-40 overflow-y-auto z-10">
                              {vendorSuggestions.map((item) => (
                                <li
                                  key={item.vendorId}
                                  className="px-2 py-1 hover:bg-slate-100 cursor-pointer text-xs"
                                  onClick={() =>
                                    handleSelect(index, "vendor", item)
                                  }
                                >
                                  {item.vendorName}
                                </li>
                              ))}
                            </ul>
                          )}
                      </td>

                      {/* Sell */}
                      <td className="px-2 py-2 text-center">
                        <input
                          type="text"
                          className="w-full h-8 border border-slate-400 rounded px-2 text-xs bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-green-600"
                          value={row.sell}
                          onChange={(e) =>
                            tablehandleChange(index, "sell", e.target.value)
                          }
                        />
                      </td>

                      {/* Buy */}
                      <td className="px-2 py-2 text-center">
                        <input
                          type="text"
                          className="w-full h-8 border border-slate-400 rounded px-2 text-xs bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-green-600"
                          value={row.buy}
                          onChange={(e) =>
                            tablehandleChange(index, "buy", e.target.value)
                          }
                        />
                      </td>

                      {/* Module */}
                      <td className="px-2 py-2">
                        <select
                          className="w-full h-8 border border-slate-400 rounded px-2 text-xs bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-green-600"
                          value={row.module}
                          onChange={(e) =>
                            tablehandleChange(index, "module", e.target.value)
                          }
                        >
                          <option value="">-- Select Module --</option>
                          {moduleList.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.divisionName}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* Delete */}
                      <td className="px-2 py-2 text-center">
                        <span
                          className="text-red-600 font-bold cursor-pointer"
                          onClick={() => handleDeleteRow(index)}
                        >
                          ✖
                        </span>
                      </td>
                    </tr>
                  ))}

                  {/* Add More Button */}
                  <tr className="border-t border-slate-200">
                    <td className="px-2 py-3">
                      <button
                        type="button"
                        className="bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded"
                        onClick={handleAddRow}
                      >
                        Add More Charges
                      </button>
                    </td>
                    <td colSpan={6}></td>
                  </tr>
                </tbody>
              </table>

              {/* Save Button */}
              <div className="text-center mt-4">
                      <CelebrationButton
           onClick={() => handleSave()}
           label={" Save / Update"}
  className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded text-sm font-medium"
           icon={<></>}
           isSuccess={isAnimate}
           />
               
              </div>
            </div>
          </div>
        </div>
      </>
    </motion.div>
  );
};

export default AddressBookAccount;